import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";
import Image from '@/models/WebsiteProduct/Image/Image'
import Region from "@/models/Region/Region";
import Country from "@/models/Country/Country";
import WebsiteProductText from "./WebsiteProductText/WebsiteProductText";
import WebsiteCategory from "@/models/WebsiteCategory/WebsiteCategory";
import orderBy from 'lodash/orderBy';
import WebsiteProductCountry from "@/models/WebsiteProduct/WebsiteProductCountry";
import WebsiteProductRegion from "@/models/WebsiteProduct/WebsiteProductRegion";
import WebsiteProductWebsiteCategory from "@/models/WebsiteProduct/WebsiteProductWebsiteCategory";

export default class WebsiteProduct extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-product';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteProducts';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_id: this.number(null).nullable(),
            text: this.attr(null),
            website_title: this.attr(null),
            website_subtitle: this.attr(null),
            days_website_subtitle: this.attr(null),
            in_feeds: this.boolean(null),
            header_image_id: this.number(null).nullable(),
            featured_image_id: this.number(null).nullable(),
            headerImage: this.belongsTo(PublicImage, 'header_image_id'),
            featuredImage: this.belongsTo(PublicImage, 'featured_image_id'),
            productTexts: this.hasMany(WebsiteProductText, 'website_product_id', 'id'),
            websiteCategories: this.belongsToMany(WebsiteCategory, WebsiteProductWebsiteCategory,'website_product_id', 'website_category_id'),
            countries: this.belongsToMany(Country, WebsiteProductCountry,'website_product_id', 'country_id'),
            regions: this.belongsToMany(Region, WebsiteProductRegion,'website_product_id', 'region_id'),
            websiteProductImages: this.hasMany(Image, 'website_product_id', 'id'),
        }
    }

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api().where('is_active', true).get();
    }

    /**
     *
     * @returns {*}
     */
    ProductTexts() {
        return WebsiteProductText.byWebsiteProductId(this.id);
    }

    /**
     *
     * @param regions
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncRegions(regions) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('regions').find(this.id).regions.forEach(region => {
                region.pivot.$delete();
            });
        }).action(this.id + '/sync-regions').update(regions);
    }

    /**
     *
     * @param countries
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncCountries(countries) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('countries').find(this.id).countries.forEach(country => {
                country.pivot.$delete();
            });
        }).action(this.id + '/sync-countries').update(countries);
    }

    /**
     *
     * @param websiteCategories
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncWebsiteCategories(websiteCategories) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('websiteCategories').find(this.id).websiteCategories.forEach(category => {
                category.pivot.$delete();
            });
        }).action(this.id + '/sync-website-categories').update({websiteCategories: websiteCategories});
    }

    /**
     *
     * @param countries
     */
    setWebsiteProductCountries(countries) {
        console.log(countries);
        throw 'setWebsiteProductCountries';

        //VuexStore.mutate(this.constructor.entity, 'setWebsiteProductCountries', {websiteProduct: this, countries: countries});
    }

    /**
     *
     * @param regions
     */
    setWebsiteProductRegions(regions) {
        console.log(regions);
        throw 'setWebsiteProductRegions';
        // VuexStore.mutate(this.constructor.entity, 'setWebsiteProductRegions', {websiteProduct: this, regions: regions});
    }

    /**
     *
     * @param websiteCategories
     */
    setWebsiteProductWebsiteCategories(websiteCategories) {
        console.log(websiteCategories);
        throw 'setWebsiteProductWebsiteCategories';
        // VuexStore.mutate(this.constructor.entity, 'setWebsiteProductWebsiteCategories', {websiteProduct: this, websiteCategories: websiteCategories});
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Countries() {
        throw 'countriesByWebsiteProduct';
        // return VuexStore.get(this.constructor.entity, 'countriesByWebsiteProduct', this.id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteCategories() {
        throw 'countriesByWebsiteProduct';
        // return VuexStore.get(this.constructor.entity, 'websiteCategoriesByWebsiteProduct', this.id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Regions() {
        throw 'countriesByWebsiteProduct';
        // return VuexStore.get(this.constructor.entity, 'regionsByWebsiteProduct', this.id);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    HeaderImage() {
        return PublicImage.find(this.header_image_id);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    FeaturedImage() {
        return PublicImage.find(this.featured_image_id);
    }

    /**
     *
     * @constructor
     */
    ProductImages() {
        return orderBy(Image.byWebsiteProductId(this.id), 'sort_order');
    }

    /**
     *
     * @returns {*}
     */
    productTexts() {
        return WebsiteProductText.byWebsiteProductId(this.id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    ProductInformation() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.product_information !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Inclusive() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.inclusive !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Exclusive() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.exclusive !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    ImportantInformation() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.important_information !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Highlights() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.highlights !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    CarRental() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.car_rental !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    AllInclusive() {
        return WebsiteProductText.byWebsiteProductId(this.id).find(text => text.all_inclusive !== undefined);
    }
}
